
function calculateScore(courseStatus){

    if (courseStatus.passed === 0) {
        return 0;
    }

    return Math.round((courseStatus.passed / courseStatus.scoAmount) * 100);
}

function calculateLessonStatus(courseStatus, masteryScore, isForCredit ){

    const completionScore = (courseStatus.completed / courseStatus.scoAmount) * 100,
        succeeded = completionScore >= masteryScore;

    if( !isForCredit ) {
        return succeeded ? "completed" : "incomplete";
    }

    if (succeeded) {
        return "passed";
    }

    // Only if all relevant lessons have been processed AND cmi.core.credit is set to credit
    if ((courseStatus.completed + courseStatus.failed) === courseStatus.scoAmount) {
        return "failed";
    }

    return "incomplete";
}

function calculateExitStatus(lessonStatus) {
    return (lessonStatus === "incomplete") ? "suspend" : "";
}

export const StatusCalculator = {
    calculateStatus: ( courseStatus, masteryScore, isForCredit ) =>{
        const lessonStatus = calculateLessonStatus(courseStatus, masteryScore, isForCredit);
        return {
            score: calculateScore(courseStatus),
            lessonStatus: lessonStatus,
            exitStatus: calculateExitStatus(lessonStatus)
        };
    }
};
